// 상세페이지 라우트
import React from "react";
import {Navigate} from "react-router-dom";
import {Loader, middleware, RouteType} from "shared/utils/RouteUtiles";

export const DetailPagesRoutes: RouteType[] = [
  {
    path: '/Notice/Notice/:id',
    label: '모집공고 상세',
    element: (
      <Loader
        route={{
          label: 'NoticeDetall',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/Notice/View/NoticeDetall')),
        }}
      />
    ),
  },
  {
    path: '/Notice/PdfAttachmentViewer/:attachmentId',
    label: 'PDF 첨부파일 미리보기',
    element: (
      <Loader
        route={{
          label: 'pdf',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/Notice/View/PdfAttachmentViewer')),
        }}
      />
    ),
  },
  {
    path: '/Notice/PdfAttachmentViewer',
    label: 'PDF 첨부파일 미리보기',
    element: (
      <Loader
        route={{
          label: 'pdf',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/Notice/View/PdfAttachmentViewer')),
        }}
      />
    ),
  },
  {
    path: '/Notice/Announcement/:id',
    label: '공지사항상세페이지',
    element: (
      <Loader
        route={{
          label: 'announcement',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/Notice/View/AnnouncementDetail')
          ),
        }}
      />
    ),
  },
  {
    path: '/Notice/AnnouncementSelectionRes/:id',
    label: '선정결과공고상세페이지',
    element: (
      <Loader
        route={{
          label: 'announcement',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/Notice/View/AnnouncementSelectionResDetail')
          ),
        }}
      />
    ),
  },
  {
    path: '/Notice/BusinessInfoNoti/:id',
    label: '지원사업안내상세페이지',
    element: (
      <Loader
        route={{
          label: 'announcement',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/Notice/View/BusinessInfoNotiDetail')
          ),
        }}
      />
    ),
  },
  {
    path: '/SupportForUse/ReferenceRoom/:id',
    label: '자료실상세페이지',
    element: (
      <Loader
        route={{
          label: 'reference',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/SupportForUse/View/ReferenceRoomDetail')
          ),
        }}
      />
    ),
  },
  {
    path: '/MyPage/InquiryMmt/OneByOneMmt/:id',
    label: '1:1문의상세',
    element: (
      <Loader
        route={{
          label: 'OneByOneMmtDetail',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/MyPage/InquiryMmt/OneByOneMmtDetail')
          ),
        }}
      />
    ),
  },
  {
    path: '/EventNews/HonsaEvent/:id',
    label: '소식/행사 상세',
    element: (
      <Loader
        route={{
          label: 'honsa',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/EventNews/View/HonsaEventDetail')
          ),
        }}
      />
    ),
  },
  {
    path: '/EventNews/Event/:id',
    label: '이벤트 상세',
    element: (
      <Loader
        route={{
          label: 'honsa',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/EventNews/View/EventDetail')
          ),
        }}
      />
    ),
  },
  {
    path: '/EventNews/Newsletter/:id',
    label: '뉴스레터 상세',
    element: (
      <Loader
        route={{
          label: 'honsa',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/EventNews/View/NewsletterDetail')
          ),
        }}
      />
    ),
  },
  {
    path: '/MyPage/UsageMmt/TreadmillMmt/:id',
    label: '디딤널상세',
    element: (
      <Loader
        route={{
          label: 'treadmill',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/MyPage/UsageMmt/TreadmillMmtDetail')
          ),
        }}
      />
    ),
  },
  {
    path: '/MyPage/UsageMmt/FacilityReservationMmt/:id',
    label: '시설예약상세',
    element: (
      <Loader
        route={{
          label: 'reservation',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/MyPage/UsageMmt/FacilityReservationMmtDetail')
          ),
        }}
      />
    ),
  },
  {
    path: '/MyPage/UsageMmt/FacilityReservationMmt/edit/:id',
    label: '시설예약수정',
    element: (
      <Loader
        route={{
          label: 'reservationEdit',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/MyPage/UsageMmt/FacilityReservationMmtEdit')
          ),
        }}
      />
    ),
  },
  {
    path: '/EventNews/ResInfoSharing/:id',
    label: '자유게시판 상세',
    element: (
      <Loader
        route={{
          label: 'resource',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/EventNews/View/ResInfoSharingDetail')
          ),
        }}
      />
    ),
  },
  {
    path: 'ResourceInfoSharing',
    label: '자유게시판 의견작성',
    element: (
      <Loader
        route={{
          label: 'resource',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/EventNews/ResourceInfoSharing')
          ),
        }}
      />
    ),
  },
  {
    path: '/SupportForUse/UserManual/:id',
    label: '사용자매뉴얼상세',
    element: (
      <Loader
        route={{
          label: 'manual',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/SupportForUse/View/UserManualDetail')
          ),
        }}
      />
    ),
  },
  {
    path: '/SupportForUse/FrequentlyAskedQuestions/:id',
    label: '자주묻는질문',
    element: (
      <Loader
        route={{
          label: 'question',
          layout: 'basic',
          element: React.lazy(
            () =>
              import(
                '~/pages/SupportForUse/View/FrequentlyAskedQuestionsDetail'
                )
          ),
        }}
      />
    ),
  },
  {
    path: '/SupportForUse/OneByOneInquiry/Detail/:id',
    label: '1:1문의 상세',
    element: (
      <Loader
        route={{
          label: 'OneByOneInquiryDetail',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/SupportForUse/View/OneByOneInquiryDetail')
          ),
        }}
      />
    ),
  },
  {
    path: '/SupportForUse/OneByOneInquiry/Write',
    label: '1:1문의 작성',
    element: (
      <Loader
        route={middleware({
          label: 'OneByOneInquiryWrite',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/SupportForUse/View/OneByOneInquiryWrtie')
          ),
        }, ['auth'])}
      />
    ),
  },
  {
    path: '/Community/IntroductionBusGroup/:id',
    label: '시설예약상세페이지',
    element: (
      <Loader
        route={{
          label: 'reservation',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/Community/IntroductionBusGroupDetail')
          ),
        }}
      />
    ),
  },
  {
    path: '/FacilityReservation/ReservationUseDirect/:id',
    label: '시설 이용신청 상세(디자인)',
    element: (
      <Loader
        route={{
          label: 'reservation',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/FacilityReservation/detail/ReservationUseDirectDet')
          ),
        }}
      />
    ),
  },
  {
    path: '/FacilityReservation/ReservationUseStartUp/:id',
    label: '시설 이용신청 상세(캠프)',
    element: (
      <Loader
        route={{
          label: 'reservation',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/FacilityReservation/detail/ReservationUseDirectDet')
          ),
        }}
      />
    ),
  },
  {
    path: '/Community/ReservationOne/:id',
    label: '시설예약시간선택페이지',
    element: (
      <Loader
        route={{
          label: 'reservation',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/Community/ReservationOne')),
        }}
      />
    ),
  },
  {
    path: '/FacilityReservation/ReservationUseDirect/form/:id',
    label: '시설예약신청페이지(집적단지)',
    element: (
      <Loader
        route={middleware(
          {
            label: 'reservation',
            layout: 'basic',
            element: React.lazy(
              () => import('~/pages/FacilityReservation/detail/ReservationTwo')
            ),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/FacilityReservation/ReservationUseStartUp/form/:id',
    label: '시설예약신청페이지(캠프)',
    element: (
      <Loader
        route={middleware(
          {
            label: 'reservation',
            layout: 'basic',
            element: React.lazy(
              () => import('~/pages/FacilityReservation/detail/ReservationTwo')
            ),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/MyPage/ExpertApplication',
    label: '평가위원 신청',
    element: (
      <Loader
        route={{
          label: 'expert',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/SupportForUse/ExpertApplication')
          ),
        }}
      />
    ),
  },
  {
    path: '/SupportForUse/ExpertApplication',
    label: '평가위원 신청 (리다이렉트)',
    element: <Navigate to="/MyPage/ExpertApplication" replace />,
  },
  {
    path: '/SupportForUse/ExpertApplicationDetail01',
    label: '전문가신청(신청자정보) (리다이렉트)',
    element: <Navigate to="/MyPage/ExpertApplication/Detail01" replace />,
  },
  {
    path: '/SupportForUse/ExpertApplicationDetail02',
    label: '전문가신청(커리어정보) (리다이렉트)',
    element: <Navigate to="/MyPage/ExpertApplication/Detail02" replace />,
  },
  {
    path: '/SupportForUse/ExpertApplicationDetail03',
    label: '전문가신청(신청완료) (리다이렉트)',
    element: <Navigate to="/MyPage/ExpertApplication/Detail03" replace />,
  },
  {
    path: '/MyPage/ExpertApplication/Detail01',
    label: '전문가신청(신청자정보)',
    element: (
      <Loader
        route={{
          label: 'expert',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/SupportForUse/View/ExpertApplicationDetail01')
          ),
        }}
      />
    ),
  },
  {
    path: '/MyPage/ExpertApplication/Detail02',
    label: '전문가신청(커리어정보)',
    element: (
      <Loader
        route={{
          label: 'expert',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/SupportForUse/View/ExpertApplicationDetail02')
          ),
        }}
      />
    ),
  },
  {
    path: '/MyPage/ExpertApplication/Detail03',
    label: '전문가신청(신청완료)',
    element: (
      <Loader
        route={{
          label: 'expert',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/SupportForUse/View/ExpertApplicationDetail03')
          ),
        }}
      />
    ),
  },
  {
    path: '/Notice/Notice/BusinessAppMgt/BusinessApp/:id',
    label: '신청체크리스트',
    element: (
      <Loader
        route={middleware({
          label: 'expert',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/BusinessAppMgt/BusinessApp')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/Notice/Notice/BusinessAppMgt/BusinessAppInfo/:id',
    label: '신청자정보',
    element: (
      <Loader
        route={middleware({
          label: 'expert',
          layout: 'basic',
          element: React.lazy(
            () => import('../pages/BusinessAppMgt/BusinessAppInfo')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/BusinessAppMgt/BusinessAppConfirmInfo/:id',
    label: '신청정보',
    element: (
      <Loader
        route={middleware({
          label: 'expert',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/BusinessAppMgt/BusinessAppConfirmInfo')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/BusinessAppMgt/BusAppMgtDetail/:id',
    label: '사업신청 관리 상세',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/biz/BusinessAppMgt/BusAppMgtDetail')
          ),
        },["auth"])}
      />
    ),
  },
  {
    path: '/biz/EvaluationMgt/SubmissionMaterials/:id',
    label: '발표자료 제출',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/biz/EvaluationMgt/View/SubmissionMaterials')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/ContractMgt/BusinessPlanMgtDetail/:id',
    label: '사업계획서관리 상세',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/biz/ContractMgt/View/BusinessPlanMgtDetail')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/ContractMgt/ElectronicAgtMgtDetail/:id',
    label: '전자협약관리 상세',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/biz/ContractMgt/View/ElectronicAgtMgtDetail')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/ContractMgt/AgreementChangeMgtApp/:id',
    label: '협약변경관리 신청',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/biz/ContractMgt/View/AgreementChangeMgtApp')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/ContractMgt/AgreementChangeMgtApp00/:id',
    label: '협약변경관리 신청 과제정보',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/biz/ContractMgt/AgreementChangeMgtApp00')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/ContractMgt/AgreementChangeMgtApp01/:id',
    label: '협약변경관리 신청 참여기업',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/biz/ContractMgt/AgreementChangeMgtApp01')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/ContractMgt/AgreementChangeMgtApp02/:id',
    label: '협약변경관리 신청 참여인력',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/biz/ContractMgt/AgreementChangeMgtApp02')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/ContractMgt/AgreementChangeMgtApp03/:id',
    label: '협약변경관리 신청 사업비',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/biz/ContractMgt/AgreementChangeMgtApp03')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/ContractMgt/AgreementChangeMgtApp04/:id',
    label: '협약변경관리 신청 비목별사업비',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/biz/ContractMgt/AgreementChangeMgtApp04')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/ContractMgt/AgreementChangeMgtApp05/:id',
    label: '협약변경관리 신청 신청자정보',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/biz/ContractMgt/AgreementChangeMgtApp05')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/ContractMgt/AgreementChangeMgtApp06/:id',
    label: '협약변경관리 신청 과제책임자',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/biz/ContractMgt/AgreementChangeMgtApp06')
          ),
        },['auth'])}
      />
    ),
  },

  {
    path: '/biz/EvaluationMgt/ObjectionDetail/:id',
    label: '협약변경관리 상세',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/biz/EvaluationMgt/View/ObjectionDetail')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/EvaluationMgt/EvaluationResultDetail/:id',
    label: '평가결과 상세',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/biz/EvaluationMgt/View/EvaluationResultInquiryDetail')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/TaskManagement/PerformanceMgtDetail/:id',
    label: '성과상세페이지',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/biz/TaskManagement/PerformanceMgtDetail')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/TaskManagement/ReportSubmissionDetail/:id',
    label: '보고서 제출',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () =>
              import('~/pages/biz/TaskManagement/View/ReportSubmissionDetail')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/biz/Mypage/ParticipatInSfSy/:id',
    label: '설문 상세',
    element: (
      <Loader
        route={middleware({
          label: 'biz',
          layout: 'basic',
          element: React.lazy(
            () =>
              import('~/pages/biz/TaskManagement/ParticipatInSfSyDetail')
          ),
        },['auth'])}
      />
    ),
  },
  {
    path: '/AdvisoryCoordinating/AdvisoryGroupInfo/:id',
    label: '전문가 자문단 상세',
    element: (
      <Loader
        route={{
          label: 'AdvisoryGroupInfoDetail',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/AdvisoryCoordinating/detail/AdvisoryGroupInfoDetail')
          ),
        }}
      />
    ),
  },
  {
    path: '/MyPage/AdvisoryCoordinatingMmt/AdvisoryGroupMmt/Apply',
    label: '전문가 자문단 지원',
    element: (
      <Loader
        route={{
          label: 'AdvisoryGroupApplicationForm',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/MyPage/AdvisoryCoordinatingMmt/AdvisoryGroupMmt/apply/AdvisoryGroupApplicationForm')
          ),
        }}
      />
    ),
  },
  {
    path: '/MyPage/AdvisoryCoordinatingMmt/AdvisoryGroupMmt/Detail/:advisoryId',
    label: '전문가 자문단 지원 상세',
    element: (
      <Loader
        route={{
          label: 'AdvisoryGroupApplicationMmt',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/MyPage/AdvisoryCoordinatingMmt/AdvisoryGroupMmt/detail/AdvisoryGroupApplicationMmt')
          ),
        }}
      />
    ),
  },
  {
    path: '/MyPage/AdvisoryCoordinatingMmt/AdvisoryGroupMmt/Form/:advisoryId',
    label: '전문가 자문단 지원 수정/보완',
    element: (
      <Loader
        route={{
          label: 'AdvisoryGroupApplicationFormMmt',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/MyPage/AdvisoryCoordinatingMmt/AdvisoryGroupMmt/detail/AdvisoryGroupApplicationFormMmt')
          ),
        }}
      />
    ),
  },
  {
    path: '/MyPage/AdvisoryCoordinatingMmt/AdvisoryGroupMmt/ReportForm/:activityId',
    label: '전문가 자문단 결과보고서 등록/수정',
    element: (
      <Loader
        route={{
          label: 'AdvisoryGroupResultReportFormMmt',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/MyPage/AdvisoryCoordinatingMmt/AdvisoryGroupMmt/detail/AdvisoryGroupResultReportFormMmt')
          ),
        }}
      />
    ),
  },
  {
    path: '/MyPage/AdvisoryCoordinatingMmt/AdvisoryGroupMmt/Report/:activityId',
    label: '전문가 자문단 결과보고서 상세',
    element: (
      <Loader
        route={{
          label: 'AdvisoryGroupResultReportMmt',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/MyPage/AdvisoryCoordinatingMmt/AdvisoryGroupMmt/detail/AdvisoryGroupResultReportMmt')
          ),
        }}
      />
    ),
  },
  {
    path: '/AdvisoryCoordinating/AdvisoryApplication/Form',
    label: '전문가 자문 신청',
    element: (
      <Loader
        route={middleware({
          label: 'AdvisoryApplicationForm',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/AdvisoryCoordinating/detail/AdvisoryApplicationForm')
          ),
        }, ['auth'])}
      />
    ),
  },
  {
    path: '/MyPage/AdvisoryCoordinatingMmt/ApplicationMmt/Adv/Detail',
    label: '전문가 자문 신청 상세',
    element: (
      <Loader
        route={middleware({
          label: 'AdvisoryApplicationMmt',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/MyPage/AdvisoryCoordinatingMmt/ApplicationMmt/detail/AdvisoryApplicationMmt')
          ),
        }, ['auth'])}
      />
    ),
  },
  {
    path: '/MyPage/AdvisoryCoordinatingMmt/ApplicationMmt/Adv/Form/:id',
    label: '전문가 자문 신청 수정/보완',
    element: (
      <Loader
        route={middleware({
          label: 'AdvisoryApplicationFormMmt',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/MyPage/AdvisoryCoordinatingMmt/ApplicationMmt/detail/AdvisoryApplicationFormMmt')
          ),
        }, ['auth'])}
      />
    ),
  },

  {
    path: '/AdvisoryCoordinating/CoordinatingApplication/Form',
    label: '코디네이팅 신청',
    element: (
      <Loader
        route={middleware({
          label: 'CoordinatingApplicationForm',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/AdvisoryCoordinating/detail/CoordinatingApplicationForm')
          ),
        }, ['auth'])}
      />
    ),
  },
  {
    path: '/MyPage/AdvisoryCoordinatingMmt/ApplicationMmt/Coord/Detail/:applyId',
    label: '코디네이팅 신청 상세',
    element: (
      <Loader
        route={middleware({
          label: 'CoordinatingApplicationMmt',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/MyPage/AdvisoryCoordinatingMmt/ApplicationMmt/detail/CoordinatingApplicationMmt')
          ),
        }, ['auth'])}
      />
    ),
  },
  {
    path: '/MyPage/AdvisoryCoordinatingMmt/ApplicationMmt/Coord/Form/:applyId',
    label: '코디네이팅 신청 수정/보완',
    element: (
      <Loader
        route={middleware({
          label: 'CoordinatingApplicationFormMmt',
          layout: 'basic',
          element: React.lazy(
            () => import('~/pages/MyPage/AdvisoryCoordinatingMmt/ApplicationMmt/detail/CoordinatingApplicationFormMmt')
          ),
        }, ['auth'])}
      />
    ),
  },
].map((route: Partial<RouteType>) => ({
  ...route,
  layout: String(route.path ?? '').includes('PdfAttachmentViewer')
    ? 'empty'
    : 'space',
})) as RouteType[];

// 공통 라우트
export const UtilityRoutes: RouteType[] = [
  {
    path: 'factor',
    label: '비밀번호 확인',
    element: (
      <Loader
        route={middleware(
          {
            label: 'factor',
            layout: 'basic',
            element: React.lazy(() => import('~/pages/Factor')),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: 'Mypage/MemberInfoMmt/MemberInfoMdf',
    label: '회원정보변경',
    element: (
      <Loader
        route={middleware(
          {
            label: 'MemberInfoMdf',
            layout: 'basic',
            element: React.lazy(
              () => import('~/pages/MyPage/MemberInfoMmt/MemberInfoMdf')
            ),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: 'MyPage/MemberInfoMmt/BusinessConversionEnter',
    label: '사업자 전환 입력폼',
    element: (
      <Loader
        route={middleware(
          {
            label: 'BusinessConversionEnter',
            layout: 'basic',
            element: React.lazy(
              () =>
                import('~/pages/MyPage/MemberInfoMmt/BusinessConversionEnter')
            ),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: 'MyPage/MemberInfoMmt/BusinessConversionFinish',
    label: '사업자 전환 완료',
    element: (
      <Loader
        route={middleware(
          {
            label: 'BusinessConversionFinish',
            layout: 'basic',
            element: React.lazy(
              () =>
                import('~/pages/MyPage/MemberInfoMmt/BusinessConversionFinish')
            ),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: 'MyPage/MemberInfoMmt/BusinessConversionSpool',
    label: '사업자 전환 실패',
    element: (
      <Loader
        route={middleware(
          {
            label: 'BusinessConversionSpool',
            layout: 'basic',
            element: React.lazy(
              () =>
                import('~/pages/MyPage/MemberInfoMmt/BusinessConversionSpool')
            ),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: 'MyPage/MemberInfoMmt/MemberInfoOut',
    label: '회원탈퇴',
    element: (
      <Loader
        route={middleware(
          {
            label: 'MemberInfoOut',
            layout: 'basic',
            element: React.lazy(
              () => import('~/pages/MyPage/MemberInfoMmt/MemberInfoOut')
            ),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/MyPage/MemberInfoMmt/EnterpriseInfoMgt',
    label: '기업정보 관리',
    element: (
      <Loader
        route={middleware(
          {
            label: 'EnterpriseInfoMgt',
            layout: 'basic',
            element: React.lazy(
              () => import('~/pages/MyPage/MemberInfoMmt/EnterpriseInfoMgt')
            ),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/MyPage/MemberInfoMmt/EnterpriseInfoMgt/CorporateInfoDetail/:id',
    label: '기업정보 상세',
    element: (
      <Loader
        route={middleware(
          {
            label: 'CorporateInfoDetail',
            layout: 'basic',
            element: React.lazy(
              () => import('~/pages/MyPage/MemberInfoMmt/detail/CorporateInfoDetail')
            ),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: 'MyPage/MemberInfoMmt/EnterpriseInfoMgt/CorporateInfoMmt',
    label: '기업정보 입력',
    element: (
      <Loader
        route={middleware(
          {
            label: 'CorporateInfoMmt',
            layout: 'basic',
            element: React.lazy(
              () => import('~/pages/MyPage/MemberInfoMmt/detail/CorporateInfoMmt')
            ),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/MyPage/MemberInfoMmt/EnterpriseInfoMgt/PerformanceRegister',
    label: '성과조사 등록',
    element: (
      <Loader
        route={middleware(
          {
            label: 'PerformanceRegister',
            layout: 'basic',
            element: React.lazy(
              () => import('~/pages/MyPage/MemberInfoMmt/detail/PerformanceRegister')
            ),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: '/MyPage/MemberInfoMmt/EnterpriseInfoMgt/PerformanceDetail',
    label: '성과조사 상세',
    element: (
      <Loader
        route={middleware(
          {
            label: 'PerformanceDetail',
            layout: 'basic',
            element: React.lazy(
              () => import('~/pages/MyPage/MemberInfoMmt/detail/PerformanceDetail')
            ),
          },
          ['auth']
        )}
      />
    ),
  },
  {
    path: 'information',
    label: '개인정보처리방침',
    element: (
      <Loader
        route={{
          label: 'sign',
          layout: 'space',
          element: React.lazy(() => import('~/pages/Information')),
        }}
      />
    ),
  },
  {
    path: 'TosContent',
    label: '이용약관',
    element: (
      <Loader
        route={{
          label: 'sign',
          layout: 'space',
          element: React.lazy(() => import('~/pages/TosContent')),
        }}
      />
    ),
  },
  {
    path: 'Registration',
    label: '실증장비등록',
    element: (
      <Loader
        route={{
          label: 'Registration',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/Registration/Registration')),
        }}
      />
    ),
  },
  {
    path: 'EquipmentList',
    label: '실증장비조회',
    element: (
      <Loader
        route={{
          label: 'EquipmentList',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/Registration/EquipmentList')),
        }}
      />
    ),
  },
  {
    path: 'EquipmentList/:id',
    label: '실증장비상세',
    element: (
      <Loader
        route={{
          label: 'EquipmentDetail',
          layout: 'basic',
          element: React.lazy(() => import('~/pages/Registration/EquipmentDetail')),
        }}
      />
    ),
  },
].map((route: Partial<RouteType>) => ({
  ...route,
  layout: 'space',
})) as RouteType[];